import { atom, Getter } from 'jotai';
import { loadable } from 'jotai/utils';
import { ApiTeams } from '../api/apiTerms';

export const refresh = <T>(fn: (get: Getter) => T) => {
  const refreshCounter = atom(0);

  return atom(
    (get) => {
      get(refreshCounter);
      return fn(get);
    },
    (_, set) => set(refreshCounter, (i) => i + 1)
  );
};

const termsOfUseAtom = atom(async () => {
  return await ApiTeams.get();
});
export const loadableTermsOfUseAtom = loadable(termsOfUseAtom);
